import { Grid, useMediaQuery, useTheme } from "@mui/material";

import bgSection03Mobile from '../Arena/assets/bg-secao-03-mobile-1.png'


export default function ThirdSection() {
    const theme = useTheme();

    const matchesMobile = useMediaQuery(theme.breakpoints.down('sm'));


    return (
        <Grid
            container
            className="section"
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: matchesMobile && '80px 16px'
            }}
        >
            <img
                src={bgSection03Mobile} alt=""
                style={{
                    position: 'relative',
                }}
            />
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                fontFamily: 'Manrope',
                color: '#FCFCFC',
                position: 'absolute',
                fontSize: matchesMobile ? 32 : 48,
                gap: matchesMobile && 16
            }}>
                {
                    matchesMobile ?
                        <>
                            <p style={{
                                textAlign: 'center'
                            }}>“Alunos Hardwork ouvem as vozes dos professores na hora da prova...”</p>
                        </> :

                        <>
                            <p>“Alunos Hardwork ouvem as vozes </p>
                            <p>dos professores na hora da prova...”</p>
                        </>
                }

                <p style={{
                    fontWeight: 700
                }}>Sabe por que?</p>
            </div>
        </Grid>
    )
}